import React, { createRef } from 'react';
import parse from 'html-react-parser';
import Accordion from 'react-bootstrap/Accordion';
// components
import IconsHolder from '../icons-holder/IconsHolder';
// scripts
import { IMenu, ILink } from './header-interfaces';
import CustomLink from '../custom-link/CustomLink';
import { pageType } from '../../interfaces';

type HeaderDropdownProps = {
  backToMenu?: any;
  menu: IMenu;
  pageType: pageType;
};

type HeaderDropdownState = {
  tabHoverId: string;
};
export default class HeaderDropdown extends React.Component<
  HeaderDropdownProps,
  HeaderDropdownState
> {
  tabRef: any = createRef();

  constructor(props: HeaderDropdownProps) {
    super(props);
    this.state = {
      tabHoverId: ''
    };
  }

  handleTabLinkMouseOver(id: string) {
    this.setState(() => ({
      tabHoverId: id
    }));
  }

  handleTabLinkMouseLeave() {
    if (!this.tabRef.current.matches(':hover')) {
      this.setState(() => ({
        tabHoverId: ''
      }));
    }
  }

  backToMenu(id: string): void {
    this.props.backToMenu(id);
  }

  render() {
    return (
      <div className={`dropdown-wrapper ${this.props.menu.id}-drp`}>
        <div className="container py-3 d-flex d-lg-none back-menu">
          <button
            type="button"
            onClick={() => this.backToMenu(this.props.menu.id)}
            className="btn p-0 h6 text-center w-100"
            aria-label="Back to the previous menu.">
            <span>{this.props.menu.tabName}</span>
          </button>
        </div>
        <div className="content flex-fill justify-content-lg-between d-flex flex-column flex-lg-row">
          <ul className="container nav-links py-lg-4 text-sm-left pb-3 px-lg-0">
            {this.props.menu.drpMainCategories.map((category, index) => {
              if (category.link && category.title) {
                return (
                  <li
                    // eslint-disable-next-line react/no-array-index-key
                    key={`${this.props.menu.id}-m-${index}`}
                    className={`d-flex align-items-center position-relative ${
                      this.state.tabHoverId === `${this.props.menu.id}-tab-${index}` ? 'active' : ''
                    }`}
                    onMouseEnter={() =>
                      this.handleTabLinkMouseOver(`${this.props.menu.id}-tab-${index}`)
                    }
                    onMouseLeave={() => this.handleTabLinkMouseLeave()}>
                    <IconsHolder
                      icon={category.icon}
                      variant="primary"
                      className="align-self-start"
                      size="md"
                    />
                    <div className="ms-3">
                      <CustomLink
                        isLink={category.linkType === this.props.pageType}
                        className="h6 stretched-link"
                        href={category.link}>
                        {parse(category.title)}
                      </CustomLink>
                      {category.subcopy && (
                        <p className="body-text-sm text-gray mb-0">{parse(category.subcopy)}</p>
                      )}
                    </div>
                  </li>
                );
              }
              return null;
            })}
          </ul>
          <div
            ref={this.tabRef}
            className="nav-add flex-fill">
            <div className="container d-lg-flex align-items-lg-start py-3 p-lg-0">
              {this.props.menu.drpTabFixed && (
                <div className="fixed-tab-container py-3 p-lg-6">
                  <h6 className="eyebrow-text mb-3 text-secondary">
                    {this.props.menu.drpTabFixed.title}
                  </h6>
                  <ul className="ps-0">
                    {this.props.menu.drpTabFixed.links.map((link: ILink, i: number) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <li key={`header-${i}-key8`}>
                        <CustomLink
                          isLink={link.linkType === this.props.pageType}
                          href={link.link}>
                          {parse(link.title)}
                        </CustomLink>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              <div className="py-3 p-lg-6">
                <h6
                  id={`${this.props.menu.id}-advtitle`}
                  className="eyebrow-text mb-lg-3 text-secondary">
                  {this.props.menu.adviceTitle}
                </h6>
                <Accordion
                  flush
                  id={`${this.props.menu.id}-tab-wrap`}
                  alwaysOpen
                  className="tab-wrap mb-0 accordion-angle-icon accordion-lg-none">
                  {this.props.menu.drpMainCategories.map((cat, index) => (
                    <Accordion.Item
                      // eslint-disable-next-line react/no-array-index-key
                      key={`${this.props.menu.id}-key2-${index}`}
                      eventKey={`${this.props.menu.id}-tab${index}-wrap`}>
                      <Accordion.Button
                        aria-controls={`${this.props.menu.id}-tab${index}`}
                        className="tabpanel-control body-text-sm d-lg-none">
                        {cat.advice.mobileTitle}
                      </Accordion.Button>
                      <Accordion.Body
                        aria-labelledby={`${this.props.menu.id}-advtitle`}
                        as="ul"
                        id={`${this.props.menu.id}-tab${index}`}
                        className={`advice-box pl-md-0 ${
                          this.state.tabHoverId === `${this.props.menu.id}-tab-${index}` ||
                          (!this.state.tabHoverId && index === 0)
                            ? 'd-lg-block'
                            : 'd-lg-none'
                        }`}>
                        {cat.advice.links.map((link, i) => (
                          // eslint-disable-next-line react/no-array-index-key
                          <li key={`${this.props.menu.id}-key3-${i}`}>
                            <CustomLink
                              isLink={link.linkType === this.props.pageType}
                              href={`${link.link}`}>
                              {parse(link.title)}
                            </CustomLink>
                          </li>
                        ))}
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
